import { render, staticRenderFns } from "./LotForm.vue?vue&type=template&id=1503b922&scoped=true&"
import script from "./LotForm.vue?vue&type=script&lang=js&"
export * from "./LotForm.vue?vue&type=script&lang=js&"
import style0 from "./LotForm.vue?vue&type=style&index=0&id=1503b922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1503b922",
  null
  
)

export default component.exports